import Button from "@/components/Button";
import { useCountryStripeProduct } from "@/src/features/pricing/hooks/useCountryStripeProduct";
import clsx from "clsx";
import Image from "next/image";
import { useMemo } from "react";

const PlanCard = ({ plan, planType }) => {
  const { prices, isLoading } = useCountryStripeProduct();

  const planPrice = prices?.find((price) => {
    return (
      price.recurring?.interval === (planType === "yearly" ? "year" : "month")
    );
  });

  const metadata = planPrice?.metadata;

  const computedPlanPrice = useMemo(() => {
    if (!planPrice) return "Price unavailable";
    return planType === "yearly" ? metadata?.module_price : metadata?.heading;
  }, [planType, planPrice]);

  const computedPlanSubheading = useMemo(() => {
    return planType === "yearly" ? metadata?.module_subheading : "";
  }, [planType, planPrice]);

  return (
    <div
      className={clsx(
        "flex h-full flex-col items-center rounded-2xl py-[30px] lg:py-[60px]"
      )}
      style={{ backgroundColor: plan.colourway[0].colourPreview }}
    >
      <div className="flex h-[135px] flex-col gap-[9px] lg:h-[140px]">
        <div
          className={clsx("text-center text-lg font-bold lg:text-xl")}
          dangerouslySetInnerHTML={{ __html: plan.heading }}
        ></div>
        <div
          className={clsx(
            "text-center text-[22px] font-extrabold lg:text-[32px]"
          )}
        >
          {computedPlanPrice}
        </div>
        {plan.subheading && (
          <div
            className={clsx(
              "text-center font-body text-sm font-normal text-gray-700 lg:text-[15px]"
            )}
          >
            {computedPlanSubheading}
          </div>
        )}
        {plan.freeTrialText && (
          <div className={clsx("text-center text-lg font-bold lg:text-xl")}>
            {plan.freeTrialText}
          </div>
        )}
      </div>
      {!!plan.target && plan.target.url && (
        <div className={clsx("my-[30px] w-full max-w-[256px]")}>
          <Button href={plan.target.url} theme="light" isFull>
            {plan.target.text}
          </Button>
        </div>
      )}
      <div className={clsx("space-y-2 px-6 font-body")}>
        {plan.features.split("\n").map((row) => {
          return (
            <div
              key={row}
              className={clsx(
                "flex items-center gap-1 text-sm font-normal lg:text-[15px]"
              )}
            >
              <Image
                alt="check"
                src="/images/check.svg"
                width="20"
                height="20"
              />
              <div>{row}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlanCard;
